import { Badge, Box, Group, Stack, Text } from "@mantine/core";
import logoUrl from "../assets/how-script.png";

/** The HoW script mark (400 × 164), for a frame that draws the logo its own way (the sidebar preview at /sidebar). */
export const HOW_LOGO_URL: string = logoUrl;

export interface ShellBrandProps {
  /** Which app this is: "Members", "Staff", "Control plane". */
  readonly surface: string;
  /** The church on screen, once it is known; the control plane has none. */
  readonly churchName?: string | undefined;
}

/**
 * The header's brand (owner, 2026-10-01, issue #325): the HoW logo on top, the app's badge and the church name below.
 *
 * The logo is an image named "HoW", not a heading, so every page's outline starts at its own h1 (#302). It is the
 * script mark used as a mask over the primary text colour (`.how-shell-logo` in global.css): one file, dark on the
 * light header and near-white on the dark one, which a pair of scheme-specific `<img>` cannot do reliably here
 * (UI_STANDARDS, "lightHidden/darkHidden do not work on Box component=img").
 */
export function ShellBrand({ surface, churchName }: ShellBrandProps) {
  return (
    <Stack gap={8} align="center" style={{ minWidth: 0 }}>
      <Box
        role="img"
        aria-label="HoW"
        className="how-shell-logo"
        style={{ "--how-shell-logo": `url("${logoUrl}")` }}
      />
      <Group gap={6} wrap="nowrap" style={{ minWidth: 0, maxWidth: "100%" }}>
        <Badge variant="light" color="gray" size="xs" style={{ flexShrink: 0 }}>
          {surface}
        </Badge>
        {churchName === undefined ? null : (
          <Text size="xs" fw={600} truncate>
            {churchName}
          </Text>
        )}
      </Group>
    </Stack>
  );
}
